import { indexCategories } from '@/mocks/home';

export default function Index() {
  return (
    <section id="index" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1024px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">
          漫画分类
        </h2>
        <p className="text-sm text-foreground-600 mb-6 md:mb-8">按类别浏览，快速找到你喜欢的漫画类型</p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexCategories.map((cat) => {
            const colorMap: Record<string, { bg: string; text: string; border: string }> = {
              primary: { bg: 'bg-primary-100', text: 'text-primary-700', border: 'border-primary-200/70' },
              accent: { bg: 'bg-accent-100', text: 'text-accent-700', border: 'border-accent-200/70' },
              secondary: { bg: 'bg-secondary-100', text: 'text-secondary-800', border: 'border-secondary-200/70' },
            };
            const c = colorMap[cat.color];
            return (
              <a
                key={cat.id}
                href="#carousel"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className={`flex items-center gap-3 p-3 md:p-4 rounded-lg border ${c.border} ${c.bg} hover:opacity-90 transition-opacity cursor-pointer`}
              >
                <div className="w-9 h-9 md:w-10 md:h-10 rounded-lg flex items-center justify-center shrink-0 bg-background-50">
                  <i className={`${cat.icon} ${c.text} text-lg md:text-xl`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-600">{cat.count.toLocaleString()} 部</p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}